
export default {

    computed: {
        variant() {
            return this.$store.state.variant;
        }
    },
    watch: {
        variant(variant) {
            this.$root.$i18n.variant = variant;
        }
    },
    created() {
        let variantMapping = {
            'smartbox' : {
                key: 'smartbox',
                brand: 'Smartbox'
            },
            'dev-smartbox.anilabs.de' : {
                key: 'smartbox',
                brand: 'Smartbox'
            },
            'stage-smartbox.anilabs.de' : {
                key: 'smartbox',
                brand: 'Smartbox'
            },
            'smartbox.animod.de' : {
                key: 'smartbox',
                brand: 'Smartbox'
            },
            'kurzinurlaub' : {
                key: 'kurzinurlaub',
                brand: 'Kurz-in-Urlaub'
            },
            'dev-gutschein-kiu.anilabs.de' : {
                key: 'kurzinurlaub',
                brand: 'Kurz-in-Urlaub'
            },
            'stage-gutschein-kiu.anilabs.de' : {
                key: 'kurzinurlaub',
                brand: 'Kurz-in-Urlaub'
            },
            'gutschein.kurz-in-urlaub.de' : {
                key: 'kurzinurlaub',
                brand: 'Kurz-in-Urlaub'
            },
            'einloesen.kurz-in-urlaub.de' : {
                key: 'kurzinurlaub',
                brand: 'Kurz-in-Urlaub'
            }
        }

        let key = this.$route.query.variant || location.hostname;
        console.log("variant-key", key);
        let variant = variantMapping[key];
        console.log("variant", variant);
        if (variant) {
            this.$store.dispatch('setVariant', variant);
        } else {
            this.$store.dispatch('setVariant', {
                key: 'animod',
                brand: 'Animod'
            });
        }
    }
};
